import {useEffect} from 'react';
import {useLocation, useNavigate} from "react-router-dom";
import {useRecoilState, useSetRecoilState} from "recoil";
import {isHandlingOauthCallbackState, userState} from "../states/user/userAtom";
import {kakaoLogin, me} from "../api/AlfyApiClient";

/**
 * 카카오 로그인 후처리를 위한 컴포넌트
 */
export default function OauthCallback() {
    console.log("called OauthCallback");
    const location = useLocation();
    const navigate = useNavigate();
    const fullUrl = `${window.location.origin}${window.location.pathname}`
    const setUser = useSetRecoilState(userState)
    const [isHandlingOauthCallback, setIsHandlingOauthCallback] = useRecoilState(isHandlingOauthCallbackState)

    const handleAuth = async () => {
        setIsHandlingOauthCallback(true)
        const searchParams = new URLSearchParams(location.search);
        const code = searchParams.get("code");
        const redirectUrl = searchParams.get("state");
        const error = searchParams.get("error");
        const errorDescription = searchParams.get("error_description");

        // 카카오에 보낸 요청이 실패한 경우
        if (error !== null) {
            // 에러 처리 후 첫 화면으로 리다이렉트
            navigate('/login');
            setIsHandlingOauthCallback(false)
            return;
        }

        const authTokens = await kakaoLogin(code!);
        if (authTokens === null) {
            console.error("failed to login with kakao");
            setIsHandlingOauthCallback(false)
            navigate('/login');
            return;
        }

        const user = await me();
        setUser(user);

        setIsHandlingOauthCallback(false)
        navigate(redirectUrl ?? '/default');
    }

    useEffect(() => {
        if (isHandlingOauthCallback) {
            return
        }

        handleAuth();
    }, []);

    return null;
}
